import React, { Fragment, useEffect, useState, useRef } from 'react'
import { Container, Row, Col, Modal, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../context/auth/useAuth'
import { Link, useParams } from 'react-router-dom'
import { getOrdersRestaurantDelivered, changeToDelivery } from '../../actions/ordersActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import ReactToPrint from 'react-to-print'
import { PrintOrder } from '../../components/printer/PrintOrder'

export default function Ordersdelivered() { 
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()
    const {restaurantid} = useParams()
	const componentRef = useRef()
	const reactToPrintRef = useRef()
	const componentRefTable = useRef()
	
	const [page, setPage] = useState(1)
	const [limit, setLimit] = useState(25)
	const [search, setSearch] = useState('')
	const [searchAux, setSearchAux] = useState('')
	const [totalRows, setTotalRows] = useState(0)

	const {orders, resultorder, total} = useSelector(state=>state.orders)

    const [modalShow, setModalShow] = useState(false)
    const [orderToShow, setOrderToShow] = useState({})
	const [orderToPrint, setOrderToPrint] = useState({})
	const [printTriggered, setPrintTriggered] = useState(false)

	useEffect(() => {
		if(client){
			if(client.restaurant){
				dispatch(getOrdersRestaurantDelivered(client.restaurant, page, limit, search))
			}else{
				dispatch(getOrdersRestaurantDelivered(restaurantid, page, limit, search))
			}
		}
	},[dispatch, t, client, restaurantid])

	useEffect(() => {
		if(client?.restaurant){
			dispatch(getOrdersRestaurantDelivered(client.restaurant, page, limit, search))
		}else{
			dispatch(getOrdersRestaurantDelivered(restaurantid, page, limit, search))
		}
	}, [page, limit, search])

	useEffect(() => {
		setTotalRows(total || 0)
	}, [total])

    const showOrder = (orderid) => {
		setOrderToShow(orders?.find(order => order._id === orderid))

		setModalShow(true)
    }

	const handlePrintOrder = async (orderid) => {
		const selectedOrder = orders?.find(order => order._id === orderid)
		setOrderToPrint(selectedOrder)
		setPrintTriggered(true)
	}
	
	useEffect(() => {
		if (printTriggered && reactToPrintRef.current) {
		  reactToPrintRef.current.handlePrint()
		  setPrintTriggered(false)
		}
	}, [printTriggered, orderToPrint])

    const setOrderDelivered = async(e, idOrder) => {
        e.preventDefault()

		dispatch(changeToDelivery(idOrder))
	}

    useEffect(() => {
        if(resultorder){
            switch (resultorder) {
                case 'changedsuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.orders.changedsuccess')
                    }).then(() => {
                        setModalShow(false)
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultorder])

	const columnsOrders = [
		{
			name: t('admin.orders.reference'),
			cell: order =>
				<div className='text-center'>
					<strong>{order?.orderReference}</strong><br/>
					{order?.orderAt?.substr(11,5)}<br/>
					{order?.orderAt?.substr(8,2)+'/'+order?.orderAt?.substr(5,2)+'/'+order?.orderAt?.substr(0,4)}<br/>
				</div>,
			selector: (order) => order?.orderReference,
			sortable: true,
		},{
			name: t('admin.orders.restaurant'),
			cell: order =>
				<div>
					{order?.restaurant}
				</div>,
			selector: (order) => order?.restaurant,
			sortable: true,
		},{
			name: t('admin.orders.delivery'),
			cell: order =>
			<div className='text-center'>
				{ new Date(Date.parse(order?.date)).getDate()<10 ? '0'+new Date(Date.parse(order?.date)).getDate() : new Date(Date.parse(order?.date)).getDate()}/{ new Date(Date.parse(order?.date)).getMonth()+1<9 ? '0'+parseInt(new Date(Date.parse(order?.date)).getMonth()+1) : parseInt(new Date(Date.parse(order?.date)).getMonth()+1)}/{ new Date(Date.parse(order?.date)).getFullYear()}<br/>
				{order?.hour}
			</div>,
			selector: (order) => order?.hour,
			sortable: true,
		},{
			name: t('admin.orders.client'),
			cell: order =>
				<div>
					{order?.user}
				</div>,
			selector: (order) => order?.user,
			sortable: true,
		},{
			name: t('admin.orders.dishes'),
			cell: order =>
				<div>
                    · {order?.firstdish?.name}<br/>
					· {order?.seconddish?.name}<br/>
					· {order?.drink?.name}<br/>
					· {order?.dessert?.name}<br/>
                    {order?.complements?.map((complement, index) =>(
                        <Fragment key={index}>· {complement?.name}<br/></Fragment>
                    ))}
				</div>,
			selector: (order) => order?.user?.name,
			sortable: false,
		},{
			name: '',
			cell: order =>
				<div>
					<i className="fa-solid fa-list fa-2x cursor me-3" onClick={() => showOrder(order?._id)}></i>
					<i className="fa-solid fa-print fa-2x cursor me-3" onClick={() => handlePrintOrder(order?._id)}></i>
				</div>,
			sortable: false,
		}
	]

	return (
        <Container className='p-5'> 
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link className="p-0 my-3" to={"/kitchen/ordersdashboard/"+restaurantid}>
                        <img src="../../../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8} className='text-center'>
                    <h1 className='fs-18'>{t('admin.orders.ordersdelivered')}</h1>
                </Col>
                <Col xs={2}></Col>
            </Row>
            <Row className="mt-5 ">
				<Col>
                	<label className='sd-label-medium'>{t('admin.orders.listordersdelivered')}</label>
				</Col>
            </Row>
            <Row>
				<Col>
					<div className="d-flex my-2">
						<input
							type="text"
							className="form-control me-2"
							placeholder={t("datatables.buscar")}
							value={searchAux || ""}
							onChange={e => {
								setSearchAux(e.target.value);
								setPage(1);
							}}
							onKeyDown={(e) => {if (e.key === 'Enter') { setSearch(searchAux); setPage(1); }}}
						/>
						<Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
					</div>
                	{orders?.length > 0 ?
						<CustomDataTable
							columns={columnsOrders}
							data={orders}
							pagination
							paginationServer
							paginationTotalRows={totalRows}
							searchable={'custom'}
							searchText={search}
							onChangeRowsPerPage={(newLimit) => {
								setLimit(newLimit)
								setPage(1)
							}}
							onChangePage={(newPage) => {
								setPage(newPage)
							}}
						/>
                    :
                        <h4 className='mt-4'>{t('admin.orders.thereisnotordersdelivered')}</h4>
                	}
				</Col>
            </Row>
            <Modal show={modalShow} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
					<Modal.Title id="contained-modal-title-vcenter" className='w-100 d-flex justify-content-between'>
						<div>{t('admin.orders.order')}: {orderToShow?.orderReference}</div>
						<div><i className='fa fa-times cursor' onClick={() => setModalShow(false)}></i></div>
					</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="px-4 formulario">
						<Row className="text-start my-3">							
							<PrintOrder order={orderToShow} ref={componentRef}/>
							<Row className='justify-content-between align-items-center'>
								<Col xs={10}>
								<div className='text-uppercase fs-6 fw-bold'>{orderToShow?.user}</div><br/>
								<div className='text-uppercase fs-5 fw-bold'>{t('admin.menus.price')}: {orderToShow?.price} €</div>
								<strong>{t('admin.orders.restaurant')}: {orderToShow?.restaurant}</strong><br/><br/>
								<div className='text-uppercase fs-6 fw-bold'>{t('admin.orders.datehour')}<br/>{orderToShow?.date?.substr(8,2)+'/'+orderToShow?.orderAt?.substr(5,2)+'/'+orderToShow?.orderAt?.substr(0,4)+' - '+orderToShow?.hour}</div><br/>
								<div className='text-uppercase fs-6 fw-bold'>{t('admin.orders.datehourorder')}<br/>{orderToShow?.orderAt?.substr(8,2)+'/'+orderToShow?.orderAt?.substr(5,2)+'/'+orderToShow?.orderAt?.substr(0,4) + ' - ' +orderToShow?.orderAt?.substr(11,5)}</div><br/>
								· {t('admin.orders.firstdish')}: {orderToShow?.firstdish?.name}<br/>
								· {t('admin.orders.seconddish')}: {orderToShow?.seconddish?.name}<br/>
								· {t('admin.orders.drink')}: {orderToShow?.drink?.name}<br/>
								· {t('admin.orders.dessert')}: {orderToShow?.dessert?.name}<br/>
									{orderToShow?.complements?.length > 0 ?
										<Fragment>
											<strong>{t('admin.orders.complements')}</strong><br/>
											{orderToShow?.complements?.map((complement, index) =>(
												<div key={index} className='ps-3'>{complement?.name}<br/></div>
											))}
										</Fragment>
										:
											<></>
									}
								</Col>
								<Col xs={2}>
									<ReactToPrint
										trigger={() => <i className='fas fa-print fa-3x cursor'></i>}
										content={() => componentRef.current}
									/>
								</Col>
							</Row>
						</Row>
						<Row className="text-start my-3">
							<Button type="button" className="btn-primary my-2 w-100" onClick={(e) => setOrderDelivered(e, orderToShow?._id)}>
								<label className='label-button'>{t('admin.orders.changetodelivery')}</label>
							</Button>
						</Row>
					</div>
                </Modal.Body>
            </Modal>
			{orderToPrint ? 
				<>
					<PrintOrder order={orderToPrint} ref={componentRefTable}/> 
					<ReactToPrint
						ref={reactToPrintRef}
						trigger={() => <></>}
						content={() => componentRefTable.current}
					/>
				</>
				: 
				''
			}
        </Container>
	)
}